// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2hLtz","ranges":"BmiRanges_ranges__NV9KH"};